module.exports = __webpack_public_path__ + "img/dg.dg0daff5b.svg";